import { FunctionComponent } from 'react';
import Header from './Header';
interface IDefaultLayoutProps {}
const DefaultLayout: FunctionComponent<IDefaultLayoutProps> = ({
  children
}) => {
  return <>
            <Header data-sentry-element="Header" data-sentry-source-file="DefaultLayout.tsx" />
            {children}
        </>;
};
export default DefaultLayout;